<template>
  <div class="dbtable">
    <el-card class="searchForm" shadow="never">
      <sc-form ref="formRef" :config="searchConfig" v-model="tableParams" @keySubmit="searchSubmit">
        <el-button type="primary" @click="searchSubmit">搜索</el-button>
        <el-button @click="clear">清空</el-button>
      </sc-form>
    </el-card>

    <div class="edit_row" v-if="!hideAdd">
      <slot name="edit_row">
        <el-button type="primary" icon="el-icon-plus" @click="add"></el-button>
        <el-button type="danger" plain icon="el-icon-delete" @click="dels">
        </el-button>
      </slot>

    </div>

    <scTable ref="table" :tableName="tableName" :apiObj="apiObj" :params="tableAndFormParams" :data="data"
      :height="height" :size="size" :border="border" :stripe="stripe" :pageSize="pageSize" :pageSizes="pageSizes"
      :rowKey="rowKey" :summaryMethod="summaryMethod" :column="column" :showSummary="showSummary"
      :remoteSort="remoteSort" :remoteFilter="remoteFilter" :remoteSummary="remoteSummary"
      :objectSpanMethod="objectSpanMethod" :hidePagination="hidePagination" :hideDo="hideDo" :hideRefresh="hideRefresh"
      :hideSetting="hideSetting" :paginationLayout="paginationLayout" :operation="operation"
      @changeSelection="changeSelection" @dels="dels">
      <!-- <template v-for="(item, index) in column" :key="index">
        <el-table-column
          v-if="!item.hide"
          :column-key="item.prop"
          :label="item.label"
          :prop="item.prop"
          :width="item.width"
          :sortable="item.sortable"
          :fixed="item.fixed"
          :filters="item.filters"
          :filter-method="remoteFilter || !item.filters ? null : filterHandler"
          :show-overflow-tooltip="item.showOverflowTooltip"
          :align="item.align || 'center'"
        >
          <template #default="scope">
            <slot v-if="item.type == 'icon'">
              <el-icon size="32"><component :is="scope.row.icon" /></el-icon>
            </slot>
            <slot v-if="item.type == 'image'">
              <el-image :src="scope.row[item.prop]" :style="item.options.style" />
            </slot>
            <slot v-else-if="item?.options?.remote && item.options.remote.api">
              {{ getLabel($store.state.dicData.dicData.get(item.options?.remote?.api), scope.row[item.prop], item.options.props) }}
            </slot>
            <slot v-else-if="typeof item.render == 'function'">
              <div v-html="item.render(scope.row)"></div>
            </slot>
            <slot v-else :name="item.prop" v-bind="scope">
              {{ scope.row[item.prop] }}
            </slot>
          </template>
</el-table-column>
</template> -->
      <!-- <template></template> -->
      <template #operation="scope">
        <slot v-if="!hideView" name="view" :scope="scope">
          <el-button type="primary" link @click="openDescriptions(scope)">查看</el-button>
        </slot>
        <slot name="edit" :scope="scope">
          <el-button v-if="!hideEdit" type="primary" link @click="openDialog(scope.row)">{{ editText }}</el-button>
        </slot>
        <slot v-if="!hideDel" name="delete" :scope="scope">
          <el-button type="danger" link @click="del(scope.row)">{{ delText }}</el-button>
        </slot>
        <slot name="other" :scope="scope"> </slot>
      </template>
    </scTable>

    <!-- <el-descriptions v-if="isView" :column="1" border size="default">
      <el-descriptions-item v-for="(val, key) in viewForm" :key="key" :label="key">{{ val }}</el-descriptions-item>
    </el-descriptions> -->
    <scDialog ref="dialog" :formModel="dialogForm" :isAdd="isAdd" :title="dialogTitle" :config="config"
      @submit="dialogSubmit"> </scDialog>
    <scDialog ref="viewDialog" :formModel="viewForm" :isAdd="isView" :title="dialogTitle" :showSubmit="false"
      :config="config">
      <el-descriptions :direction="config?.direction || 'vertical' || 'horizontal'"
        :label-width="config?.labelWidth || 100" v-if="isAdd == isView" :column="config?.column || 1" border
        size="default">
        <el-descriptions-item class-name="description_item" label-class-name="label_class_name"
          :label-width="item?.options?.labelWidth || 200" :span="1" v-for="(item, key) in config.formItems"
          :rowspan="item?.options?.rowspan || 1" :key="key" :label="item.label">
          <view v-if="item.render">{{ item.render(viewForm) }}</view>
          <view v-else>{{ viewForm[item.name] }}</view>
        </el-descriptions-item>
      </el-descriptions>
    </scDialog>
  </div>
</template>

<script>
import config from "@/config/table"
// import scTable from "@/components/scTable"
// import scDialog from "@/components/scDialog"
export default {
  name: "dbtable",
  props: {
    tableName: { type: String, default: "" },
    apiObj: { type: Object, default: () => { } },
    params: { type: Object, default: () => ({}) },
    data: { type: Object, default: () => { } },
    height: { type: [String, Number], default: "100%" },
    size: { type: String, default: "default" },
    border: { type: Boolean, default: false },
    stripe: { type: Boolean, default: false },
    pageSize: { type: Number, default: config.pageSize },
    pageSizes: { type: Array, default: config.pageSizes },
    rowKey: { type: String, default: "" },
    summaryMethod: { type: Function, default: null },
    column: { type: Object, default: () => { } },
    remoteSort: { type: Boolean, default: false },
    remoteFilter: { type: Boolean, default: false },
    remoteSummary: { type: Boolean, default: false },
    objectSpanMethod: { type: Function, default: () => { } },
    showSummary: { type: Boolean, default: false },
    hidePagination: { type: Boolean, default: false },
    hideDo: { type: Boolean, default: false },
    hideRefresh: { type: Boolean, default: false },
    hideSetting: { type: Boolean, default: false },
    paginationLayout: { type: String, default: config.paginationLayout },
    operation: { type: Boolean, default: true },
    config: { type: Object, default: () => { } },
    searchConfig: { type: Object, default: () => ({}) },
    hideAdd: { type: Boolean, default: false },
    hideView: { type: Boolean, default: false },
    hideEdit: { type: Boolean, default: false },
    hideDel: { type: Boolean, default: false },
    delMsg: { type: String, default: "是否移除该条数据 ?" },
    delText: { type: String, default: "删除" },
    editText: { type: String, default: "编辑" }
  },
  // components: { scTable, scDialog },
  data() {
    return {
      searchForm: {},
      tableParams: {},
      form: {},
      dialogForm: {},
      viewForm: {},
      dialogModelValue: false,
      isView: "查看",
      isAdd: "新增",
      timer: null,
      selectIds: []
    }
  },
  unmounted() {
    if (this.timer) {
      clearTimeout(this.timer)
    }
  },
  watch: {
    tableParams: {
      handler(newValue) {
        this.tableParams = newValue
        this.$emit("update:params", newValue)
      },
      deep: true
    },
    dialogForm: {
      handler(newValue) {
        this.$emit("update:dialogForm", newValue)
      },
      deep: true
    }
  },
  computed: {
    dialogTitle() {
      return this.isAdd
    },
    tableAndFormParams() {
      return Object.assign({}, this.tableParams, this.params)
    }
  },
  methods: {
    changeSelection(rows) {
      console.log("rows11", rows)
      this.selectIds = rows
    },
    openDescriptions(scope) {
      const row = scope.row
      this.viewForm = this.$TOOL.objCopy(row)
      this.isAdd = this.isView
      this.$refs.viewDialog.dialogVisible = true
    },
    openDialog(row) {
      this.dialogForm = this.$TOOL.objCopy(row)
      this.isAdd = "编辑"
      this.$refs.dialog.dialogVisible = true
      this.config.formItems.forEach((item) => {
        if (item.component == "number" && this.dialogForm[item.name] != null) {
          this.dialogForm[item.name] = Number(this.dialogForm[item.name])
        }
      })
    },
    //错误示例
    // add() {
    //   //先获取formItem里面有的参数
    //   this.isAdd = "新增"
    //   const keys = []
    //   this.config.formItems.forEach((formItem) => {
    //     keys.push(formItem.name)
    //   })
    //   this.dialogForm = {}
    //   //只对有写的formItem进行归空处理
    //   keys.map((key) => {
    //     // Object.keys(this.dialogForm).map((key) => {
    //     // if (key === "parentId") debugger
    //     const value = this.dialogForm[key]
    //     if (keys.indexOf(key) === -1) {
    //       delete this.dialogForm[key]
    //       return
    //     }
    //     if (Array.isArray(value)) {
    //       this.dialogForm[key] = []
    //     } else if (value === null || value === undefined) {
    //       delete this.dialogForm[key]
    //     } else if (typeof value === "object") {
    //       this.dialogForm[key] = {}
    //     } else if (typeof value === "number") {
    //       this.dialogForm[key] = null
    //     } else {
    //       this.dialogForm[key] = ""
    //     }
    //   })
    //   console.log(this.dialogForm)
    //   this.$refs.dialog.dialogVisible = true
    // },
    //修改后
    add() {
      this.isAdd = "新增"
      // 创建一个空对象，用于存储重置后的表单值
      const emptyForm = {}

      // 遍历配置的表单项，为每个字段设置初始空值
      this.config.formItems?.forEach((item) => {
        const fieldName = item.name
        // 根据字段类型设置不同的空值
        if (item.component === "checkbox" || (item.component === "select" && item.options && item.options.multiple)) {
          emptyForm[fieldName] = [] // 多选类型设为空数组
        } else if (item.component === "number") {
          emptyForm[fieldName] = null // 数字输入框设为null
        } else if (item.component === "switch") {
          emptyForm[fieldName] = false // 开关类型设为false
        } else {
          emptyForm[fieldName] = "" // 其他类型设为空字符串
        }
      })

      // 使用Vue.set或直接赋值确保响应式更新
      this.dialogForm = emptyForm

      // 打开对话框
      this.$refs.dialog.dialogVisible = true
    },
    beforeDel() {
      return this.$confirm(`${this.delMsg}`, "提示", {
        type: "warning"
      })
        .then(() => {
          return true
        })
        .catch(() => {
          return false
        })
    },
    del(row) {
      const id = row.id
      this.beforeDel().then(async (flag) => {
        if (flag) {
          const res = await this.apiObj.del({ ids: [id] })
          if (res.success) {
            this.$refs.table.refresh()
            this.$message.success("删除成功")
          }
        }
      })
      // this.$confirm("确定删除吗？").then(async () => {})
    },
    refresh() {
      this.$refs.table.refresh()
    },
    dels() {
      this.$refs.table.dels()
    },
    getData() {
      this.$refs.table.getData()
    },
    searchSubmit() {
      if (this.timer) {
        clearTimeout(this.timer)
      }
      this.timer = setTimeout(() => {
        this.getData()
      }, 160)
      console.log(this.tableParams, this.params)
    },
    clear() {
      this.$refs.formRef.resetFields()
      this.$nextTick(() => {
        this.searchSubmit()
      })
    },
    async dialogSubmit(form) {
      console.log(11, this.isAdd)
      let res
      if (this.isAdd == '编辑') {
        if (this.apiObj.update) {
          res = await this.apiObj.update(form)
        } else {
          res = await this.apiObj.submit(form)
        }
      } else {
        res = await this.apiObj.submit(form)
      }
      // console.log(22, form)
      if (this.apiObj.type == "menu") {
        const updatedMenu = await this.apiObj.get()
        this.$TOOL.data.set("MENU", updatedMenu.data)
        window.location.reload()
        console.log("变更了MENU")
      }
      if (res.success) {
        this.$refs.dialog.dialogVisible = false
        this.$refs.table.refresh()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.dbtable {
  width: 100%;
  height: 100%;

  .edit_row {
    padding: 20px;
    width: calc(100%);
    background-color: #fff;
  }

  ::v-deep .label_class_name {
    max-width: 200px;
    // width: 100px;
    // color: #0099ff;
  }

  ::v-deep .description_item {
    // width: 100px;
    max-width: 200px;
    color: #0099ff;
    // background-color: pink;
  }
}
</style>
